export const fetchLegendData = async (geoserverUrl, layerName, styleName) => {
    if (layerName !== '' || styleName !== '' ) {
    const url = `${geoserverUrl}?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=application/json&LAYER=${layerName}&STYLE=${styleName}`;
    const response = await fetch(url);
    const data = await response.json();
    return(data.Legend[0].rules);
    }
    else {
        return ''
    }
  };